import { SettingsLayout } from "@/components/settings-layout";
import { DangerZoneTab } from "@/components/settings/danger-zone-tab";
import { authClient } from "@/lib/auth-client";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/settings/danger-zone")({
	beforeLoad: async () => {
		const { data: session } = await authClient.getSession();
		if (session?.user?.role !== "admin") {
			throw redirect({ to: "/" });
		}
	},
	component: DangerZoneSettingsPage,
});

function DangerZoneSettingsPage() {
	return (
		<SettingsLayout>
			<DangerZoneTab />
		</SettingsLayout>
	);
}
